<ng-container [ngSwitch]="filter">
<ng-container *ngSwitchCase="'dateRangeWithTime'">
    <div class="example-wrapper">
        <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <label class="example-input-wrapper">
                   <input  [style.width]="'0px'" [style.border]="'none'" [selectMode]="'range'" [(ngModel)]="dateTimeRange"
                   (ngModelChange)="onDateTimeRangeChange($event)"
                   [owlDateTime]="dtRange1">
                   <span class="tab">
                    <span [owlDateTimeTrigger]="dtRange1" id="mydate">{{name}}<i
                            class="icon-arrow"></i></span>
                   </span>
            <owl-date-time #dtRange1></owl-date-time>
        </label>
    </span> 
    </div>
</ng-container>
<ng-container *ngSwitchCase="'daterange'">
    <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span class="tab">
            <span id="mydate" name="daterangeInput" daterangepicker [options]="options" (selected)="selectedDate($event, daterangepicker)"
                (cancelDaterangepicker)="calendarEventsHandler($event, daterangepicker)" (applyDaterangepicker)="calendarEventsHandler($event, daterangepicker)">{{name}}<i
                    class="icon-arrow"></i></span>
        </span>
    </span>
</ng-container>
<ng-container *ngSwitchCase="'daterangeEconomist'">
    <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span class="tab">
            <span id="mydate" name="daterangeInput" daterangepicker [options]="optionsEconomist" (selected)="selectedDate($event, daterangepicker)"
                (cancelDaterangepicker)="calendarEventsHandler($event, daterangepicker)" (applyDaterangepicker)="calendarEventsHandler($event, daterangepicker)">{{name}}<i
                    class="icon-arrow"></i></span>
        </span>
    </span>
</ng-container>
<ng-container *ngSwitchCase="'daterangeEconomistArchive'">
    <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span class="tab">
            <span id="mydate" name="daterangeInput" daterangepicker [options]="optionsEconomistArchive" (selected)="selectedDate($event, daterangepicker)"
                (cancelDaterangepicker)="calendarEventsHandler($event, daterangepicker)" (applyDaterangepicker)="calendarEventsHandler($event, daterangepicker)">{{name}}<i
                    class="icon-arrow"></i></span>
        </span>
    </span>
</ng-container>
<ng-container *ngSwitchCase="filter === 'checkbox' || filter === 'social' ? filter : ''">
    <!-- <div [class] = "cssActive?' checkactive1':''"></div>  -->
    <span tabindex="0" id="{{name | lowercase}}FilterSpan" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span id="{{name | lowercase}}Filter" class='tab'>{{name}}<i class="icon-arrow"></i></span>
        <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
            <input #filterInput id="{{name | lowercase}}FilterInputBox" [(ngModel)]="searchText" type="text" class="textBox" placeholder="search text goes here"
                (keydown)="onKeydown($event)">
            <ul #filterList id="{{filter_Id}}" class="filter_ul">
                <ng-container *ngFor="let author of list| filter  : searchText; trackBy: trackByName; let i = index">
                    <li *ngIf="i <= 11">
                        <label class="checkblock" id="typeFilterValue{{(author.value == 'Photo Gallery') ? 'PhotoGallery'
                        : (author.value == 'Live Blog') ? 'LiveBlog'
                        : author.value | titlecase}}">
                            {{(author.value == 'story') ? 'Standard'
                            : ((author.value == 'gallery')) ? 'Photo Gallery'
                            : ((author.value == 'liveblog')) ? 'Live Blog'
                            : ((author.value == 'HT')) ? 'HT'
                            : ((author.value == 'LM')) ? 'LM'
                            : author.value | titlecase}}
                            <input #listCheckbox type="checkbox" tabindex="0" value="{{author.value}}" name="authorFilter"
                                class="checkBox" [(ngModel)]="author.isChecked" (ngModelChange)="onFilterAuthorName()" />
                            <span class="checkmark"></span> </label>
                    </li>
                </ng-container>
            </ul>
        </div>
    </span>
</ng-container>

    <ng-container *ngSwitchCase="'SectionCheckbox'">
        <!-- <div [class] = "cssActive?' checkactive1':''"></div>  -->
        <span tabindex="0" id="{{name | lowercase}}FilterSpan" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
            <span id="{{name | lowercase}}Filter" class='tab'>{{name}}<i class="icon-arrow"></i></span>
            <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
                <input #filterInput id="{{name | lowercase}}FilterInputBox" [(ngModel)]="searchText" type="text" class="textBox" placeholder="search text goes here"
                    (keydown)="onKeydown($event)">
                <ul #filterList id="{{filter_Id}}" class="filter_ul">
                    <ng-container *ngFor="let author of list| filter  : searchText; trackBy: trackByName; let i = index">
                        <li *ngIf="i <= 11">
                            <label class="checkblock">
                            {{author.value}}
                                <input #listCheckbox type="checkbox" tabindex="0" value="{{author.value}}" name="authorFilter"
                                    class="checkBox" [(ngModel)]="author.isChecked" (ngModelChange)="onFilterAuthorName()" />
                                <span class="checkmark"></span> </label>
                        </li>
                    </ng-container>
                </ul>
            </div>
        </span>
    </ng-container>

<ng-container *ngSwitchCase="'api_filter'">
    <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span id="{{name | lowercase}}Filter" class='tab'>{{name}}<i class="icon-arrow"></i></span>
        <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
            <input #filterInput [formControl]='searchQuery' class="textBox" type="text"
            placeholder="search text goes here"
            [(ngModel)]="searchText" (keydown)="onKeydown($event)"
            (focus)="searchFocus = true" (focusout)="searchFocus = false"
             />
            <ul #filterList id="{{filter_Id}}" class="filter_ul">
                <ng-container *ngFor="let author of list.sort(); let i = index">
                    <li>
                        <label class="checkblock">
                          {{author.value}}
                            <input #listCheckbox type="checkbox" tabindex="0" value="{{author.value}}" name="authorFilter"
                                class="checkBox" [(ngModel)]="author.isChecked" (ngModelChange)="onFilterAuthorName()" />
                            <span class="checkmark"></span> </label>
                    </li>
                </ng-container>
            </ul>
        </div>
    </span>
</ng-container>
<ng-container *ngSwitchCase="'checkboxNav'">
    <!-- <div [class] = "cssActive?' checkactive1':''"></div>  -->
    <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span id="{{name | lowercase}}Filter" class='tab'>{{name}}<i class="icon-arrow"></i></span>
        <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
            <input #filterInput [(ngModel)]="searchText" type="text" class="textBox" placeholder="search text goes here"
                (keydown)="onKeydown($event)">
            <ul #filterList id="{{filter_Id}}" class="filter_ul">
                <ng-container *ngFor="let author of list| filter  : searchText; trackBy: trackByName; let i = index">

                    <li *ngIf="(i <= 11 && author.value !== 'PRIMARY') || (i <= 11 && sharedService.isdomainConfig('pages','showPrimaryPage'))">
                        <label class="checkblock">
                           {{ author.value}}
                            <input #listCheckbox type="checkbox" tabindex="0" value="{{author.value}}" name="authorFilter"
                                class="checkBox" [(ngModel)]="author.isChecked" (ngModelChange)="onFilterAuthorName()" />
                            <span class="checkmark"></span> </label>
                    </li>
                </ng-container>
            </ul>
        </div>
    </span>
</ng-container>
<ng-container *ngSwitchCase="'radio'">
  <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
      <span id="{{name | lowercase}}Filter" class='tab'>{{name}}<i class="icon-arrow"></i></span>
      <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
          <input #filterInput [(ngModel)]="searchText" type="text" class="textBox" placeholder="search text goes here"
              (keydown)="onKeydown($event)">
          <ul #filterList id="{{filter_Id}}" class="filter_ul">
              <ng-container *ngFor="let author of list| filter  : searchText; trackBy: trackByName; let i = index">
                  <li *ngIf="i <= 11">
                      <label class="radioBlock">
                         {{author.value | titlecase}}
                         <input type="radio" name="{{filter_Id}}"
                         [checked]="author === list.value"
                          (click)="onRadioAuthorName(author.value)"/>
                          <span class="radiomark"></span>
                        </label>
                  </li>
              </ng-container>
          </ul>
      </div>
  </span>

</ng-container>
<ng-container *ngSwitchCase="'checkboxKeyValue'">
    <!-- <div [class] = "cssActive?' checkactive1':''"></div>  -->
    <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span id="{{name | lowercase}}Filter" class='tab'>{{name}}<i class="icon-arrow"></i></span>
        <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
            <input #filterInput [formControl]='searchQuery2'
             type="text" class="textBox" id="inputSearchField" placeholder="search text goes here"
                (keydown)="onKeydown($event)">
            <ul #filterList id="{{filter_Id}}" class="filter_ul">
                <ng-container *ngFor="let author of list| textFilter : searchText; trackBy: trackByName; let i = index">
                    <li *ngIf="i <= 11">
                        <label class="checkblock">
                            {{author.value | titlecase}}
                            <input #listCheckbox type="checkbox" tabindex="0" value="{{author.value}}" name="authorFilter"
                                class="checkBox" [(ngModel)]="author.isChecked" (ngModelChange)="onFilterAuthorName()" />
                            <span class="checkmark"></span> </label>
                    </li>
                </ng-container>
            </ul>
        </div>
    </span>
</ng-container>
<ng-container  *ngSwitchCase="'domainCheckbox'">
    <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span id="{{name | lowercase}}Filter" class='tab'>Domain<i class="icon-arrow"></i></span>
        <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
            <ul #filterList id="{{filter_Id}}" class="filter_ul">
                <ng-container *ngFor="let domains of domains| filter  : searchText; let i = index">
                    <li>
                        <label class="checkblock">
                           {{domains.name | titlecase}}{{(domains.id == domain) ? "(Current Domain)": ''}}
                           <input type="checkbox" name="authorFilter" #listCheckbox class="checkBox" value="{{domains.id}}"
                           [checked]="domains.id === list.value || domains.id === domain"
                           [(ngModel)]="domains.isChecked" (ngModelChange)="onFilterAuthorName(); updateSelectedDomains();"/>
                            <span class="checkmark"></span>
                          </label>
                    </li>
                </ng-container>
            </ul>
        </div>
    </span>
  </ng-container>
 <ng-container  *ngSwitchCase="'domainList'">
    <span *ngIf="sharedService.isdomainConfig('collection','showDomainFilter')"  tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span id="{{name | lowercase}}Filter" class='tab'>Domain<i class="icon-arrow"></i></span>
        <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
            <ul #filterList id="{{filter_Id}}" class="filter_ul">
                <ng-container *ngFor="let domains of userDomains| filter  : searchText; let i = index">
                    <li>
                        <label class="radioBlock">
                           {{domains.name | titlecase}}{{(domains.id == domain) ? "(Current Domain)": ''}}
                           <input type="radio" name="domainOptions"
                           [checked]="domains.id === list.value || domains.id === domain"
                            (click)="onRadioAuthorName(domains.id)"/>
                            <span class="radiomark"></span>
                          </label>
                    </li>
                </ng-container>
            </ul>
        </div>
    </span>
  </ng-container>
  <!--ng-container *ngSwitchCase="'gttextbox'">
    <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
            <span id="{{name | lowercase}}Filter" class='tab'>{{name}}<i class="icon-arrow"></i></span>
            <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
                <input #filterInput [formControl]='textQuery' type="number" class="textBox" placeholder="Enter value here">
            </div>
        </span>
    </span>
</ng-container-->
<ng-container *ngSwitchCase="'comparetextbox'">
    <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
            <span id="{{name | lowercase}}Filter" class='tab'>{{name}}<i class="icon-arrow"></i></span>
            <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
                <!--select [formControl]="comparisonType">
                    <option [value]="option" *ngFor="let  option of compareOptions">{{option}}</option>
                  </select-->
                  <ul #filterList id="{{filter_Id}}" class="filter_ul">
                    <ng-container *ngFor="let option of compareOptions; let i = index">
                        <li>
                            <label class="checkblock">
                                {{option.value}}
                                <input #listCheckbox type="checkbox" tabindex="0" value="{{option.value}}" name="compareFilter"
                                    class="checkBox" [(ngModel)]="option.isChecked" (ngModelChange)="changeComparator(i)" />
                                <span class="checkmark"></span> </label>
                        </li>
                    </ng-container>
                </ul>
                <input #filterInput [formControl]='textQuery' type="number" class="textBox newtext" placeholder="Enter value here">
            </div>
        </span>
    </span>
</ng-container>
<ng-container *ngSwitchCase="'singleSelectcheckbox'">
    <!-- <div [class] = "cssActive?' checkactive1':''"></div>  -->
    <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span id="{{name | lowercase}}Filter" class='tab'>{{name}}<i class="icon-arrow"></i></span>
        <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
            <input #filterInput [formControl]='searchQuery2'
             type="text" class="textBox" id="inputSearchField" placeholder="search text goes here"
                (keydown)="onKeydown($event)">
            <ul #filterList id="{{filter_Id}}" class="filter_ul">
                <ng-container *ngFor="let author of list| textFilter : searchText; trackBy: trackByName; let i = index">
                    <li>
                        <label class="checkblock">
                            {{author.value | titlecase}}
                            <input #listCheckbox type="checkbox" tabindex="0" value="{{author.value}}" name="authorFilter"
                                class="checkBox" [checked]="author.key == selectedAuthor" (click)="changeSelected(author.key)" />
                            <span class="checkmark"></span> </label>
                    </li>
                </ng-container>
            </ul>
        </div>
    </span>
</ng-container>
<ng-container *ngSwitchCase="filter === 'siteNameCheckbox' || filter === 'social' ? filter : ''">
    <!-- <div [class] = "cssActive?' checkactive1':''"></div>  -->
    <span tabindex="0" id="{{name | lowercase}}FilterSpan" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span id="{{name | lowercase}}Filter" class='tab'>{{name}}<i class="icon-arrow"></i></span>
        <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
            <input #filterInput id="{{name | lowercase}}FilterInputBox" [(ngModel)]="searchText" type="text" class="textBox" placeholder="search text goes here"
                (keydown)="onKeydown($event)">
            <ul #filterList id="{{filter_Id}}" class="filter_ul">
                <ng-container *ngFor="let author of list| filter  : searchText; trackBy: trackByName; let i = index">
                    <li>
                        <label class="checkblock" id="typeFilterValue{{(author.value == 'Photo Gallery') ? 'PhotoGallery'
                        : (author.value == 'Live Blog') ? 'LiveBlog'
                        : author.value | titlecase}}">
                            {{(author.value == 'story') ? 'Standard'
                            : ((author.value == 'gallery')) ? 'Photo Gallery'
                            : ((author.value == 'liveblog')) ? 'Live Blog'
                            : ((author.value == 'HT')) ? 'HT'
                            : ((author.value == 'LM')) ? 'LM'
                            : author.value | titlecase}}
                            <input #listCheckbox type="checkbox" tabindex="0" value="{{author.value}}" name="authorFilter"
                                class="checkBox" [(ngModel)]="author.isChecked" (ngModelChange)="onFilterAuthorName()" />
                            <span class="checkmark"></span> </label>
                    </li>
                </ng-container>
            </ul>
        </div>
    </span>
</ng-container>
 <ng-container *ngSwitchCase="'radioForCricketLiveBlog'">
    <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span id="{{name | lowercase}}Filter" class='tab'>{{name}}<i class="icon-arrow"></i></span>
        <div [class]="openFilter ? 'filterdrop block' : 'filterdrop'" #filterDrop>
            <ul #filterList id="{{filter_Id}}" class="filter_ul">
                <ng-container *ngFor="let author of list| filter  : searchText; trackBy: trackByName; let i = index">
                    <li *ngIf="i <= 11">
                        <label class="radioBlock">
                           {{author.value | titlecase}}
                           <input type="radio" name="{{filter_Id}}"
                           [checked]="author === list.value"
                            (click)="onRadioAuthorName(author.value)"/>
                            <span class="radiomark"></span>
                          </label>
                    </li>
                </ng-container>
            </ul>
        </div>
    </span>
  </ng-container>
  <ng-container *ngSwitchCase="'daterangeCricketLiveBlog'">
    <span tabindex="0" #filterEl [class]="(checkFocusInside(filterEl) ? (cssActive ? 'checkactive focused' : 'focused') : (cssActive ? 'checkactive' : ''))">
        <span class="tab">
            <span id="mydate" name="daterangeInput" daterangepicker [options]="optionsCricketLiveBlogMatchDate" (selected)="selectedDate($event, daterangepicker)"
                (cancelDaterangepicker)="calendarEventsHandler($event, daterangepicker)" (applyDaterangepicker)="calendarEventsHandler($event, daterangepicker)">{{name}}<i
                    class="icon-arrow"></i></span>
        </span>
    </span>
</ng-container>
</ng-container>
